import { Draft, produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS,
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_ATTACHMENT_SAVE,
  CONTRACT_SETUP_BY_DRAFT_REQUEST,
  CONTRACT_SETUP_BY_DRAFT_SUCCESS,
  CONTRACT_SETUP_PARTICIPANT_REMOVE,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';
import AttachmentsSaveRequest from '@app/store/contract-setup/AttachmentsSaveRequest';

interface ContractSetupAttachment {
  participantId: string;
  requests: AttachmentsSaveRequest[];
}

export type ContractSetupAttachmentState = ContractSetupAttachment[];

const initialState: ContractSetupAttachmentState = [];

const reducer = produce(
  (draft: Draft<ContractSetupAttachmentState>, action: ContractSetupAction) => {
    switch (action.type) {
      case CONTRACT_SETUP_ALL_STATE_CLEAR:
      case CONTRACT_SETUP_BY_DRAFT_REQUEST:
      case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST:
        return initialState;
      case CONTRACT_SETUP_ATTACHMENT_SAVE: {
        const { participantId, requests } = action.payload;
        const index = draft.findIndex((item) => item.participantId === participantId);
        const attachments = {
          participantId,
          requests,
        };
        if (index === -1) {
          draft.push(attachments);
        } else {
          draft[index].requests = requests;
        }
        return draft;
      }
      case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS: {
        const { participantAttachments } = action.payload;
        participantAttachments.forEach((participantAttachment) => {
          const { participant, request } = participantAttachment;
          const { participantId } = participant;
          const { attachmentType, message, required } = request;
          const index = draft.findIndex((item) => item.participantId === participantId);
          if (index === -1) {
            draft.push({
              participantId,
              requests: [
                {
                  attachmentType,
                  message,
                  required,
                },
              ],
            });
          } else {
            draft[index].requests.push({
              attachmentType,
              message,
              required,
            });
          }
        });
        return draft;
      }
      case CONTRACT_SETUP_PARTICIPANT_REMOVE:
        return draft.filter(
          (attachment) => attachment.participantId !== action.payload.participantId
        );
      case CONTRACT_SETUP_BY_DRAFT_SUCCESS: {
        const { participants } = action.payload;
        participants.forEach((participant) => {
          const { attachmentRequests, id } = participant;
          draft.push({
            participantId: id,
            requests: attachmentRequests.map(({ message, required, name }) => ({
              attachmentType: name,
              message,
              required,
            })),
          });
        });
        return draft;
      }
      default:
        return draft;
    }
  },
  initialState
);

export default reducer;
